import { FC } from "react";

import { IFormField, IOption } from "models/app";
import { InputTypes } from "constants/enums";
import RHTextField from "./RHTextField";
import RHPasswordField from "./RHPasswordField";
import RHAutoComplete from "./RHAutoComplete";
//import RHCalender from './RHCalender';
import RHSwitch from "./RHSwitch";
import RHPhoneNumber from "./RHPhoneNumber";
import RHCalender from "./RHCalender";
import RHColor from "./RHColor";
import RHDropzoneSingle from "./RHDropzoneSingle";
import RHCheckBox from "./RHCheckBox";
import RHCountryCode from "./RHCountryCode";
import RHPhone from "./RHPhone";
import RHTimePicker from "./RHTimePicker";

interface Props extends IFormField {
  errors: any;
  control: any;
  watch: any;
  reset: any;
  setValue: any;
  register: any;
  options?: IOption[];
  required?: boolean;
  defaultValue?: any;
}

const FormFields: FC<Props> = (props) => {
  const { type, hidden } = props;

  const renderField = (): React.ReactNode => {
    if (hidden) return null;
    if (
      type === InputTypes.TEXT ||
      type === InputTypes.HIDDEN ||
      type === InputTypes.NUMBER ||
      type === InputTypes.EMAIL ||
      type === InputTypes.TEXTAREA
    )
      return <RHTextField {...props} />;

    if (type === InputTypes.COUNTRY) return <RHCountryCode {...props} />;

    if (type === InputTypes.PHONE) return <RHPhoneNumber {...props} />;

    if (type === InputTypes.PASSWORD) return <RHPasswordField {...props} />;

    if (type === InputTypes.MULTI_SELECT)
      return (
        <RHAutoComplete
          {...props}
          multiple={true}
          defaultValue={props.defaultValue || []}
        />
      );

    if (type === InputTypes.SWITCH) return <RHSwitch {...props} />;

    if (type === InputTypes.FILE) return <RHDropzoneSingle {...props} />;

    if (type === InputTypes.SELECT) return <RHAutoComplete {...props} />;

    if (type === InputTypes.CALENDER) return <RHCalender {...props} />;

    if (type === InputTypes.TIME) return <RHTimePicker {...props} />;

    if (type === InputTypes.COLOR) return <RHColor {...props} />;

    if (type === InputTypes.CHECKBOX) return <RHCheckBox {...props} />;

    return null;
  };

  return <>{renderField()}</>;
};

export default FormFields;
